// React
import React, { useState, useEffect } from 'react';

// material UI
import Snackbar from '@material-ui/core/Snackbar';
import withStyles from '@material-ui/core/styles/withStyles';
import Hidden from '@material-ui/core/Hidden';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Alert from '@material-ui/lab/Alert';

// Utils
import { keyEmptyCheck } from 'aurora-utils/utils';
import messages from 'aurora-translations';
import PropTypes from 'prop-types';
import { useClipboard } from 'aurora-hooks';

// Componants
import { ADGMBreadcrumbs, ADGMImage } from 'aurora-components';
import { StepperV2, Footer } from 'aurora-section-components';
import Loading from 'aurora-components/Loading';

import styles from './styles';

function InitiatorFlowLayout({
  breadCrumbs,
  application,
  error,
  loading,
  activeStep,
  hideCancelBtn,
  children,
  steps,
  handleStep,
  handleBack,
  handleNext,
  stepperTitle,
  classes,
  hideNextIcon,
}) {
  const { copy } = useClipboard();

  const [showSnackbar, setShowSnackbar] = useState(false);

  useEffect(() => {
    if (error?.statusCode || error?.message || error) setShowSnackbar(true);
  }, [error]);

  return (
    <Container className={classes.container}>
      {loading && <Loading />}
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={showSnackbar}
        onClose={() => setShowSnackbar(false)}
        autoHideDuration={3000}
      >
        <Alert
          onClose={() => {
            setShowSnackbar(false);
          }}
          severity='error'
          variant='filled'
          sx={{ width: '100%' }}
        >
          {messages[error?.message]?.id ? keyEmptyCheck(error?.message) : error?.message}
        </Alert>
      </Snackbar>
      <Hidden mdDown>
        <div className={classes.breadcrumbsHolder}>
          <ADGMBreadcrumbs paths={breadCrumbs?.filter(item => item.text)} />
          <Typography className={classes.serviceid}>
            {keyEmptyCheck('Application_ID')} : <strong>{application?.applicationDetails?.applicationNumber}</strong>
          </Typography>
        </div>
      </Hidden>
      <div className={classes.mobileTitlehead}>
        <div>
          <Link href='/app/services'>
            <ADGMImage name='croseblackonmobile.svg' alt='croseimg' />
            {keyEmptyCheck(application?.applicationType)}
          </Link>
        </div>
        <div>
          <Typography variant='body1'>
            {keyEmptyCheck('Application_ID')}:{' '}
            <span className={classes.fontWeight600}>
              {application?.applicationDetails?.applicationNumber}{' '}
              <ADGMImage
                onClick={() => copy(application?.applicationDetails?.applicationNumber)}
                className={classes.copyRightEvent}
                name='ApplicationIDicon.svg'
                alt='ApplicationIDicon'
              />
            </span>
          </Typography>
        </div>
      </div>
      <Grid container spacing={3} className={classes.flowContentContainer}>
        <Grid item xs={12} md={12}>
          {steps?.length > 0 && (
            <StepperV2
              customTitle={keyEmptyCheck(stepperTitle)}
              {...{
                application,
                steps,
                handleStep,
                activeStep,
                hideCancelBtn,
              }}
            />
          )}
        </Grid>

        <Grid item xs={12} md={12}>
          {children}
        </Grid>
      </Grid>

      <Grid container justifyContent='center' className={classes.flowActionsContainer}>
        <Grid container item className='MuiContainer-maxWidthLg'>
          <Grid xs={12} md={12} className={classes.actionsWrapper}>
            <Footer
              {...{
                handleNext,
                handleBack,
                activeStep,
                steps,
                loading,
                isNextBtnDisabled: loading,
                application,
                hideNextIcon,
              }}
            />
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
}

InitiatorFlowLayout.propTypes = {
  classes: PropTypes.object.isRequired,
  breadCrumbs: PropTypes.array.isRequired,
  application: PropTypes.object.isRequired,
  error: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
  activeStep: PropTypes.number.isRequired,
  hideCancelBtn: PropTypes.bool,
  stepperTitle: PropTypes.string,
  steps: PropTypes.array.isRequired,
  handleStep: PropTypes.func.isRequired,
  handleBack: PropTypes.func.isRequired,
  handleNext: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  hideNextIcon: PropTypes.bool,
};

InitiatorFlowLayout.defaultProps = {
  hideCancelBtn: false,
  hideNextIcon: false,
  stepperTitle: 'application_steps_v2',
};
export default withStyles(styles)(InitiatorFlowLayout);
